import React from "react";

const Contacto: React.FC = () => {
  return (
    <div>
            <h2>Contacto</h2>
           {" "}
      <form>
               {" "}
        <div>
                    <label htmlFor="name">Nombre:</label>
                    <input type="text" id="name" name="name" />
                 {" "}
        </div>
               {" "}
        <div>
                    <label htmlFor="email">Correo Electrónico:</label>
                    <input type="email" id="email" name="email" />
                 {" "}
        </div>
               {" "}
        <div>
                    <label htmlFor="message">Mensaje:</label>
                    <textarea id="message" name="message"></textarea>
                 {" "}
        </div>
                <button type="submit">Enviar</button>
             {" "}
      </form>
         {" "}
    </div>
  );
};

export default Contacto;
